"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontDataFromHtml = exports.getSupportedFontsFromInfopage = exports.getSupportedFontsFromTemplate = exports.getFontDataFromStylesChild = exports.generateFontStyles = exports.getSupportedFontFamilies = void 0;
var seesignage_utils_1 = require("@seesignage/seesignage-utils");
var supportedFontFamilies = {
    Arimo: 'Arimo',
    'Carter One': 'Carter One',
    Caveat: 'Caveat',
    Figtree: 'Figtree',
    Inter: 'Inter',
    Lato: 'Lato',
    Lobster: 'Lobster',
    Merriweather: 'Merriweather',
    Montserrat: 'Montserrat',
    'Montserrat Alternates': 'Montserrat Alternates',
    'Neutra Text': 'Neutra Text',
    'Noto Sans': 'Noto Sans',
    'Open Sans': 'Open Sans',
    Oswald: 'Oswald',
    'Permanent Marker': 'Permanent Marker',
    'Playfair Display': 'Playfair Display',
    Poppins: 'Poppins',
    Roboto: 'Roboto',
    'Roboto Condensed': 'Roboto Condensed',
    'Roboto Slab': 'Roboto Slab',
    Rochester: 'Rochester',
    Rufina: 'Rufina',
    'Space Grotesk': 'Space Grotesk',
    Ubuntu: 'Ubuntu'
};
var generateGoogleFontParams = function (_a) {
    var fontWeights = _a.fontWeights;
    if (fontWeights) {
        var fontData = Object.values(fontWeights);
        return ":".concat(fontData
            .map(function (_a) {
            var isItalic = _a.isItalic, fontWeight = _a.fontWeight;
            return isItalic ? "".concat(fontWeight, ",").concat(fontWeight, "i") : "".concat(fontWeight);
        })
            .join(','));
    }
    return '';
};
/**
 * Get supported Google font families for rich text editor.
 * Make sure that the corresponding typefaces are also imported
 * in SeeSignage player (seesignage-player/src/config/fonts.ts)
 */
var getSupportedFontFamilies = function () { return Object.values(supportedFontFamilies); };
exports.getSupportedFontFamilies = getSupportedFontFamilies;
/**
 * Generate google fonts imports.
 * See: https://developers.google.com/fonts/docs/getting_started
 */
var generateFontStyles = function (template, orientation, infopageContent) { return "\n".concat(getSupportedFontsFromTemplate(template, orientation)
    .map(function (font) {
    return "\n      @import url('https://fonts.googleapis.com/css?family=".concat(font.fontFamily).concat(generateGoogleFontParams(font), "');\n  ");
})
    .join(''), "\n  ").concat(infopageContent ? getSupportedFontsFromInfopage(infopageContent) : '', "\n"); };
exports.generateFontStyles = generateFontStyles;
var googleFontsSupportedWeights = {
    100: true,
    200: true,
    300: true,
    400: true,
    500: true,
    600: true,
    700: true,
    800: true,
    900: true
};
var getFontDataFromStylesChild = function (stylesChild, fonts) {
    var _a;
    var _b, _c, _d;
    if (fonts === void 0) { fonts = {}; }
    var fontFamily = (_b = stylesChild.styles) === null || _b === void 0 ? void 0 : _b.fontFamily;
    if (fontFamily) {
        fonts[fontFamily] = __assign(__assign({}, fonts[fontFamily]), { fontFamily: fontFamily });
        var stylesFontWeight = (_c = stylesChild.styles) === null || _c === void 0 ? void 0 : _c.fontWeight;
        var fontWeight = googleFontsSupportedWeights[stylesFontWeight]
            ? stylesFontWeight
            : 400; // 400 by default as it is normal font weight
        var existingFont = fonts[fontFamily];
        var existingFontWeight = existingFont.fontWeights
            ? existingFont.fontWeights[fontWeight]
            : undefined;
        var isItalic = ((_d = stylesChild.styles) === null || _d === void 0 ? void 0 : _d.fontStyle) === 'italic' || !!(existingFontWeight === null || existingFontWeight === void 0 ? void 0 : existingFontWeight.isItalic);
        fonts[fontFamily].fontWeights = __assign(__assign({}, fonts[fontFamily].fontWeights), (_a = {}, _a[fontWeight] = {
            fontWeight: fontWeight,
            isItalic: isItalic
        }, _a));
    }
    if (!stylesChild.children) {
        return {};
    }
    if (stylesChild && stylesChild.children) {
        stylesChild.children.forEach(function (child) {
            if (child) {
                getFontDataFromStylesChild(child, fonts);
            }
        });
    }
    return fonts;
};
exports.getFontDataFromStylesChild = getFontDataFromStylesChild;
var getSupportedFontsFromTemplate = function (template, orientation) {
    return Object.values(getFontDataFromStylesChild(template.components[orientation])).filter(function (_a) {
        var fontFamily = _a.fontFamily;
        return supportedFontFamilies[fontFamily] !== undefined;
    });
};
exports.getSupportedFontsFromTemplate = getSupportedFontsFromTemplate;
/**
 * Get supported fonts from infopage, if it has wysiwyg html content
 * Returns import string with all fonts found in html content
 * @param content
 */
var getSupportedFontsFromInfopage = function (content) {
    var result = '';
    for (var _i = 0, _a = Object.values(content); _i < _a.length; _i++) {
        var c = _a[_i];
        if ((0, seesignage_utils_1.isTextEditorInfopageContent)(c)) {
            var html = c.html;
            result = "".concat(result).concat(getFontDataFromHtml(html).map(function (font) {
                return "@import url('https://fonts.googleapis.com/css?family=".concat(font).concat(generateGoogleFontParams({
                    fontFamily: font
                }), "');");
            }));
        }
    }
    return result;
};
exports.getSupportedFontsFromInfopage = getSupportedFontsFromInfopage;
/**
 * Get all font families found in html string. Use regex to extract font-family names
 * @param html
 */
var getFontDataFromHtml = function (html) {
    // https://stackoverflow.com/questions/32306906/get-style-attributes-with-regex-from-html-string
    var regex = /(font-family: )[0-9A-Za-z ]+(?=;)/g;
    var matches = html.match(regex);
    var fontFamilies = matches ? matches.map(function (val) { return val.split(': ')[1]; }) : undefined;
    var uniqueFonts = fontFamilies ? Array.from(new Set(fontFamilies)) : [];
    return uniqueFonts.filter(function (fontFamily) { return supportedFontFamilies[fontFamily] !== undefined; });
};
exports.getFontDataFromHtml = getFontDataFromHtml;
//# sourceMappingURL=fonts.js.map